import { render, staticRenderFns } from "./Texto.vue?vue&type=template&id=0ce98049"
import script from "./Texto.vue?vue&type=script&lang=js"
export * from "./Texto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports